import { Field } from "@progress/kendo-react-form";
import { JobReminder } from "../../../data/serviceReminderData";
import { FormCheckbox } from "../FormComponents";

interface Props {
    reminders: JobReminder[]
    handleCompleteReminder: (id: number, checked: boolean) => void
}

const JobsRemidners = ({ reminders, handleCompleteReminder }: Props) => {

    console.log(reminders)

    return (
        <div>
            {
                reminders.length ? (
                    <div>
                        {
                            reminders.map((reminder, index) => (
                                <div>
                                    <Field
                                        name={index.toString()}
                                        component={FormCheckbox}
                                        onChange={(e) => handleCompleteReminder(reminder.serviceReminderId, e.value)}
                                        label={
                                            <span style={{display: "inline-flex", flexFlow: "column"}}>
                                                <span>
                                                    {`Reminder - ${reminder.client}`}
                                                </span>
                                                <span style={{opacity:"0.6"}}>
                                                    {reminder.description}
                                                </span>
                                            </span>
                                    }
                                    /> 
                               </div>
                            ))
                        }
                    </div>
                ) : (
                    <div> No reminders found </div>
                )
            }
        </div>
    )
}

export default JobsRemidners;